/// <reference path="../../typings/tsd.d.ts" />
module warsApp.services {

    export class UserActionTransientDataDto {
        public userActionId: string;
        public comment: string;
        public docIds: string[];
        public effectiveDate: Date;
        public processActionWorkflowBlockId: string;
        public documents: Wars.Domain.Model.Dtos.DocumentDto[];
    }

    export class UserActionService {

        private userActionId: string;
        private comment: string;
        private docIds: string[];
        private effectiveDate: Date;
        private processActionWorkflowBlockId: string;
        private documents: Wars.Domain.Model.Dtos.DocumentDto[];

        constructor() { }

        public storeTransientUserActionData(userActionId: string, comment: string, docIds: string[], effectiveDate: Date, processActionWorkflowBlockId: string): void {
            var self = this;
            self.comment = comment;
            self.docIds = docIds;
            self.effectiveDate = effectiveDate;
            self.processActionWorkflowBlockId = processActionWorkflowBlockId;
            self.userActionId = userActionId;
        }

        public updateDocuments(documents: Wars.Domain.Model.Dtos.DocumentDto[]) {
            var self = this;
            self.documents = documents;
        }

        public getTransientUserActionData(userActionId: string): UserActionTransientDataDto {
            var self = this;
            if (self.userActionId === userActionId) {
                var dto = new UserActionTransientDataDto();
                dto.userActionId = self.userActionId;
                dto.comment = self.comment;
                dto.docIds = self.docIds;
                dto.effectiveDate = self.effectiveDate;
                dto.processActionWorkflowBlockId = self.processActionWorkflowBlockId;
                dto.documents = self.documents;
                //self.clearTransientUserActionData();
                return dto;
            }
            self.clearTransientUserActionData();
            return null;
        }
        
        public clearTransientUserActionData() {
            var self = this;
            self.comment = undefined;
            self.docIds = undefined;
            self.effectiveDate = undefined;
            self.processActionWorkflowBlockId = undefined;
            self.userActionId = undefined;
            self.documents = [];
        }
    }
}

warsApp.registerService("UserActionService", []);